export const DELETE_INVOICE_CODE_FROM_TRANSACTION = {
    REQUEST: 'DELETE_INVOICE_CODE_FROM_TRANSACTION_REQUEST',
    SUCCESS: 'DELETE_INVOICE_CODE_FROM_TRANSACTION_SUCCESS',
    FAILED: 'DELETE_INVOICE_CODE_FROM_TRANSACTION_FAILED',
};

export const CLEAR_MODAL_INVOICE_CODE_2_TRANSACTION = 'CLEAR_MODAL_INVOICE_CODE_2_TRANSACTION';
